import React, { useEffect, Component, Fragment, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import useApiStatusDispatch from "../../hooks/useApiStatusDispatch.js";
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { Button, Col, Container, Form, Modal, Row, Table, InputGroup } from 'react-bootstrap';
import {
  getClientsList
} from "../eventsView/eventsViewSlice.js";
import {
  getAllMetricsByCategory,
  logMetricProgress,
  selectMetricById,
  editMetricProgress,
  deleteProgressData,
} from "../../state/metricListSlice";
import './Metric.css';
import { selectTrainerParam } from '../users/usersSlice'

import DatePicker from "react-datepicker"


function AddProgress({props}) {

  const [currentClientsName, setCurrentClientsName] = useState("Client");
  const [addDate, setaddDate] = useState(null)
  const [availableMetrics, setAvailableMetrics] = useState([])
  const [metricEdits, setMetricEdits] = useState({})
  const [addNotes, setAddNotes] = useState("")

  const dispatch = useDispatch();
  const statusDispatch = useApiStatusDispatch();
  const location = useLocation()
    
  const history = useHistory()
  
  // let clientId = window.location.href.split('=')[1]
  // const url = new URL(window.location.href);
  // const trainerId = (new URL(window.location.href)).searchParams.get("trainer");
	const trainerParam = useSelector(selectTrainerParam)
  const clientId = (new URL(window.location.href)).searchParams.get("clientId")?.split('?')[0];


  useEffect(() => {
    dispatch(getClientsList());
    setaddDate(today)
  }, []);

  // const clientsList = useSelector((state) => state.events.clientsList);
  const clientsList = useSelector((state) => state.users.clients.entities);

  useEffect(() => {
      if (Object.values(clientsList).length > 0) {
        let specifiedClient = clientsList[clientId]
        let name =specifiedClient.user_name
        console.log('specifiedClient: ', specifiedClient)
        name = name.charAt(0).toUpperCase() + name.slice(1)
        setCurrentClientsName(name)
      }
  }, [clientsList]);



  const getMetrics = () => {
    let type;
    let include_progress_data=1
    let include_empty_groups=0
    if (clientId === 0){
      type = 'default'
    } else {
      type = 'client'
    }
    let client_Id=parseInt(clientId)
    const payload = {
      type,
      client_Id,
      include_progress_data,
      include_empty_groups
    }
    dispatch(getAllMetricsByCategory(payload))
  }
  const getMetricsThenRedirect = () => {
    let type;
    let include_progress_data=1
    let include_empty_groups=0
    if (clientId === 0){
      type = 'default'
    } else {
      type = 'client'
    }
    let client_Id=parseInt(clientId)
    const payload = {
      type,
      client_Id,
      include_progress_data,
      include_empty_groups
    }
    dispatch(getAllMetricsByCategory(payload)).then(() => {
      history.push(`/metric-graphs?clientId=${clientId}&${trainerParam}`)
    })
  }

  useEffect(() => {
    getMetrics();
  }, []);

  //grabs metric object from the store, makes into an array then alphabetizes  
  let metrics = (Object.values(useSelector((state) => state.metrics.entities))).sort(function(a,b){
    let textA = a.assessment_name.toUpperCase();
    let textB = b.assessment_name.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  })

  //grabs category object from the store, makes into an array then alphabetizes
  const categories = Object.values(useSelector((state) => state.metrics.categories.entities)).sort(function(a,b){
    let textA = a.category.toUpperCase();
    let textB = b.category.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  })

  // upon a metric value added adds the info into the metric edits object
  const handleManyMetricEdits = (metric, edit) => {
    let metricEditChanges = JSON.parse(JSON.stringify(metricEdits)) // deep copy 
    if(metricEditChanges[metric.metric_id] === undefined){
        metricEditChanges[metric.metric_id] = {metric,value:''}
    }
    if(edit.value){
      metricEditChanges[metric.metric_id].value = edit.value
    }else if(edit.minutes){
      metricEditChanges[metric.metric_id].minutes = edit.minutes
    }else if(edit.seconds){
      metricEditChanges[metric.metric_id].seconds = edit.seconds
    }
    setMetricEdits(metricEditChanges)
  }

  // maps over the metricEdits state object and dispatches an addProgress action for each
  const handleManyEditSubmit = () => {
    let edits = Object.values(metricEdits)
    console.log('EDITS: ',edits)
    let payload;
    let addeditemValue;
    edits.forEach(edit => {
        if(edit.value !== ''||edit.minutes!==''||edit.seconds!==''){
            addeditemValue = "a:1:{i:" + edit.metric.metric_id + ";d:" + edit.value + ";}";
            payload={
                operation:"add",
                datePicker: addDate,
                notes:addNotes,
                metric_id:edit.metric.metric_id,
                value:edit.value,
                minutes:edit.minutes,
                seconds:edit.seconds,
            }
            statusDispatch(logMetricProgress(payload),"progress","add")
            // dispatch(logMetricProgress(payload))
        }
    })
    // history.push(`/metricGraphs?clientId=${clientId}&${trainerParam}`)
    getMetricsThenRedirect()
  }

  const handleCancel = () => {
    history.push(`/metric-graphs?clientId=${clientId}&${trainerParam}`)

  }

  // finds metrics that dont have a progress entry for selected date
  const isMetricAvailable = (metric) => {
    let isAvailable = true
    metric.progress_data.forEach(progress => {
      if(progress.date===addDate){
        isAvailable = false
      }  
    })
    return isAvailable
  }

  //checks if a category has a metric without a progress entry for selected date
  const hasAvailableMetric = (category) => {
    let hasAvailable = true
    let metricList = metrics.filter(metric => metric.categorization === category.category)
    let unavailableCount = 0
    metricList.forEach(metric => {
      if(metric.progress_data?.length===0){
        hasAvailable=true
      }
      metric.progress_data.forEach(progress => {
        if( progress.date === addDate ){
          // hasAvailable = false
          unavailableCount +=1
        }  
      })
    })
    if(unavailableCount === metricList.length){
      hasAvailable = false
    }
    return hasAvailable
  }

  const handleSetDate = (e) => {
    setaddDate(e.target.value)
  }

  //gets today's date and formats it
  let today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth()+1; 
  const yyyy = today.getFullYear();
  if(dd<10) {dd=`0${dd}`;} 
  if(mm<10) {mm=`0${mm}`;}
  today = `${yyyy}-${mm}-${dd}`;

  return(
    <div id="containerDiv">
      <h1 style={{lineHeight:'1.5'}}>{currentClientsName}'s Progress</h1>
      <hr/>
    <p style={{height:'35px', textAlign:'center', paddingTop:'18px'}}>Fill in any of the fields below to log progress</p>
    <div className='assessment__progressAddTable'>
      <Form style={{overflow:"hidden"}}>
        <Form.Group as={Col} className={"assessment__DateNotesContainer m-2"} style={{position:'relative'}}>
            {/* <Row style={{paddingRight:"10px", paddingLeft:"10px"}}> */}
                  <Form.Label column sm={5} style={{float:'left', fontWeight:'bold'}} id="progressDate">
                      Date:
                  </Form.Label>
                <Form.Control 
                    type="date" 
                    for="progressDate"
                    date={addDate} 
                    defaultValue={today}
                    onChange={(e) => handleSetDate(e)} 
                    style={{float:'left'}}
                >

                </Form.Control>
            {/* </Row> */}
            <Row style={{paddingRight:"10px", paddingLeft:"10px"}}>
              <Form.Label column sm={5} style={{fontWeight:'bold'}}>
                  Notes:
              </Form.Label>
              <Form.Control as="textarea" placeholder="Notes (Optional)" onChange={(e) => setAddNotes(e.target.value)} />
            </Row>
        </Form.Group>
        {categories.map((category) =>
          <>
          <h3 style={{paddingLeft:"25px"}}>{category.category}</h3>
          {hasAvailableMetric(category) ? 
          <>
          {metrics.map((metric) => 
            <>
            {metric.categorization === category.category && isMetricAvailable(metric) ? 
              <Form.Group as={Row} style={{backgroundColor:'#F5F5F5', paddingBottom:'5px', paddingTop:'5px',alignItems:'center'}}>
                <Col md={5} style={{paddingLeft:"20px"}}>
                  <Form.Label column md={8}>
                      {metric.assessment_name} 
                  </Form.Label>
                </Col>
                <Col style={{paddingRight:"20px"}}>
                  {
                    metric.unit==='time'?
                    <InputGroup>
                      <Form.Control 
                        onChange={e=>{
                          handleManyMetricEdits(metric,{minutes:e.target.value})
                        }}
                        placeholder="minutes"
                      />
                      <Form.Control 
                        onChange={e=>{
                          handleManyMetricEdits(metric,{seconds:e.target.value})
                        }}
                        placeholder="seconds"
                      />
                    </InputGroup>
                    :
                    <Form.Control 
                      type="number"
                      step="0.001" 
                      placeHolder='Value' 
                      onChange={(e) =>handleManyMetricEdits(metric,{value:e.target.value})} 
                    />
                  }
                </Col>
              </Form.Group>
              
              : null}
            </>
          )}
          </>
          : <p>This category has no metrics without a progress entry on this date</p>
          
          }
          </>
        )}
      </Form>
    </div>
      <span style={{float:"right", marginRight:"40px", paddingBottom:"40px"}}>
        <Button 
          variant="success"
          onClick={handleManyEditSubmit}
          style={{marginTop:'18px', marginLeft:'5px'}}
        >
            Submit
        </Button>
        <Button 
        variant="danger" 
        onClick={() => handleCancel()}
        style={{marginTop:'18px', marginLeft:'5px'}}
        >
            Cancel
        </Button>
      </span>
    </div>
  )
}
export default AddProgress
